import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { handleKeyPress } from '../../../utilities/keyHandler'

const scope = 'SelectBar'
export default class SelectBar extends Component {
  static propTypes = {
    title: PropTypes.string,
    options: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
    inline: PropTypes.bool,
    value: PropTypes.any,
  }

  renderContent(option) {
    if (option.icon) {
      return (
        <Fragment>
          {option.icon}
          <span className='hide-on-mobile'>{option.text}</span>
        </Fragment>
      )
    } else {
      return <Fragment>{option.text}</Fragment>
    }
  }

  render() {
    const { className, title, options, value, onSelect, inline } = this.props
    return (
      <div className={classnames(scope, inline && `${scope}_Inline`, className)}>
        <div className={classnames(`${scope}-Title`)}>{title}</div>
        {options.map(option => (
          <div
            key={option.value}
            className={classnames(`${scope}-Option`, option.value === value && `${scope}-Option_Selected`)}
            title={option.title}
            onClick={() => onSelect(option.value)}
            tabIndex={0}
            onKeyPress={ev => handleKeyPress(ev, () => onSelect(option.value))}
          >
            {this.renderContent(option)}
          </div>
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/select-bar/select-bar.jsx